import { createBrowserRouter } from "react-router-dom";
import MainLayout from "src/layouts/MainLayout";
import LoginPage from "./login/LoginPage";
import DashboardPage from "./dashboard/dashboard";
import EducationPage from "./education/EducationPage";
import Welcome from "./welcome/Welcome";
import { lazy } from "react";
import Tracking from "./tracking/Tracking";

const SSOPageAddress = "AVC_AAA/components/sign-up/sso-auth/SSOPage";
const RegisterLegalPageAddress = "AVC_AAA/pages/register-legal/RegisterLegalPage";
const RegisterRealPageAddress = "AVC_AAA/pages/register-real/RegisterRealPage";
const ForgetPasswordPageAddress = "AVC_AAA/pages/forget-password/ForgetPasswordPage";

const SSOPage = lazy(() => import("src/features/" + SSOPageAddress));
const RegisterLegalPage = lazy(() => import("src/features/" + RegisterLegalPageAddress));
const RegisterRealPage = lazy(() => import("src/features/" + RegisterRealPageAddress));
const ForgetPasswordPage = lazy(() => import("src/features/" + ForgetPasswordPageAddress));

const Routers = createBrowserRouter([
  {
    element: <MainLayout />,
    children: [{ path: "/", element: <DashboardPage /> }],
  },
  { path: "login", element: <LoginPage /> },
  { path: "forget-password", element: <ForgetPasswordPage /> },
  { path: "register-real", element: <RegisterRealPage /> },
  { path: "register-legal", element: <RegisterLegalPage /> },
  { path: "sso", element: <SSOPage /> },
  { path: "welcome", element: <Welcome /> },
  { path: "education/:combined", element: <EducationPage /> },
  { path: "education", element: <EducationPage /> },
  { path: "tracking/:combined", element: <Tracking /> },
  { path: "tracking", element: <Tracking /> },
]);

export default Routers;
